export const APP_URL = {
    LOCAL: 'http://localhost:3000/',
    DEV: 'https://mindly-dev.web.app/',
    PROD: 'https://mindly.care/',
}

export const BASE_URL = 'https://us-central1-mindly-dev.cloudfunctions.net'